import { render, staticRenderFns } from "./auctionrecord.vue?vue&type=template&id=34d920bd&scoped=true&"
import script from "./auctionrecord.vue?vue&type=script&lang=js&"
export * from "./auctionrecord.vue?vue&type=script&lang=js&"
import style0 from "./auctionrecord.vue?vue&type=style&index=0&id=34d920bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d920bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d920bd')) {
      api.createRecord('34d920bd', component.options)
    } else {
      api.reload('34d920bd', component.options)
    }
    module.hot.accept("./auctionrecord.vue?vue&type=template&id=34d920bd&scoped=true&", function () {
      api.rerender('34d920bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/list/auctionrecord.vue"
export default component.exports